import { render, staticRenderFns } from "./practice-report.vue?vue&type=template&id=607febde&scoped=true&"
import script from "./practice-report.vue?vue&type=script&lang=ts&"
export * from "./practice-report.vue?vue&type=script&lang=ts&"
import style0 from "./practice-report.vue?vue&type=style&index=0&id=607febde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607febde",
  null
  
)

export default component.exports